import { z } from "zod";
import type * as Types from "@/types/users";

export const User: z.ZodType<Types.User> = z.object({
  id: z.string(),
  displayName: z.string(),
  emailAddress: z.string(),
})